module.exports = __webpack_public_path__ + "img/cat-tablet.db8e87ed.png";